import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unixToDateTime'
})
export class UnixToDateTimePipe implements PipeTransform {

  transform(value: string, format = 'YYYY-MM-DD'): string {
    if (!value || value.length !== 14) {
      return 'Invalid input';
    }

    // Parse 'YYYYMMDDHHmmss' manually to avoid locale/timezone quirks
    const year   = +value.slice(0, 4);
    const month  = +value.slice(4, 6) - 1; // Date months are 0-indexed
    const day    = +value.slice(6, 8);
    const hour   = +value.slice(8, 10);
    const minute = +value.slice(10, 12);
    const second = +value.slice(12, 14);

    const date = new Date(year, month, day, hour, minute, second);
    if (isNaN(date.getTime())) {
      return 'Invalid date';
    }

    const pad = (n: number) => String(n).padStart(2, '0');
    return format
      .replace('YYYY', String(date.getFullYear()))
      .replace('MM',   pad(date.getMonth() + 1))
      .replace('DD',   pad(date.getDate()))
      .replace('HH',   pad(date.getHours()))
      .replace('mm',   pad(date.getMinutes()))
      .replace('ss',   pad(date.getSeconds()));
  }
}
